module.exports = __webpack_public_path__ + "assets/media/evening.a9e462ed.mp3";